'use strict'
import React, { useCallback, useEffect, useMemo, useState } from 'react'
import { connect } from 'react-redux'
import axios from 'axios'
import { useHistory, useLocation } from 'react-router-dom'
import {
  makeStyles,
  Paper,
  Toolbar,
  Typography,
  Box,
  Button,
  CircularProgress,
  TextField,
  InputAdornment,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TablePagination,
  TableRow,
  Switch,
  FormControlLabel,
  Select,
  MenuItem,
  Snackbar,
  Chip
} from '@material-ui/core'
import { Alert } from '@material-ui/lab'
import SearchIcon from '@material-ui/icons/Search'
import RefreshIcon from '@material-ui/icons/Refresh'
import ArrowBackIcon from '@material-ui/icons/ArrowBack'
import SaveIcon from '@material-ui/icons/Save'
import GetAppIcon from '@material-ui/icons/GetApp'

const useStyles = makeStyles(theme => ({
  root: {
    width: '100%',
    padding: theme.spacing(2)
  },
  paper: {
    width: '100%'
  },
  toolbar: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: theme.spacing(2),
    alignItems: 'center',
    padding: theme.spacing(2)
  },
  search: {
    minWidth: 280
  },
  tableWrapper: {
    overflowX: 'auto'
  },
  table: {
    minWidth: 1360
  },
  tableCell: {
    padding: '8px 12px'
  },
  headerCell: {
    fontWeight: 600,
    backgroundColor: theme.palette.grey[100],
    whiteSpace: 'nowrap'
  },
  nameCell: {
    minWidth: 260
  },
  addressText: {
    fontSize: '0.75rem',
    color: theme.palette.text.secondary
  },
  controlsCell: {
    minWidth: 220
  },
  saveButton: {
    minWidth: 100
  },
  statChip: {
    marginLeft: theme.spacing(1)
  },
  metricsSection: {
    padding: theme.spacing(0, 2, 2, 2)
  },
  metricsPanel: {
    padding: theme.spacing(1.5)
  },
  metricsHeader: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginBottom: theme.spacing(1)
  },
  metricsChips: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: theme.spacing(1),
    marginBottom: theme.spacing(1.5)
  },
  metricsTable: {
    minWidth: 760
  },
  moveControl: {
    minWidth: 180
  },
  moveButton: {
    marginLeft: theme.spacing(1),
    minWidth: 84
  },
  freqFixControl: {
    minWidth: 150
  },
  freqFixControlWide: {
    minWidth: 200
  },
  diffPanel: {
    marginTop: theme.spacing(1.5),
    padding: theme.spacing(1.5)
  },
  anchorPanel: {
    marginTop: theme.spacing(1.5),
    padding: theme.spacing(1.5)
  },
  anchorTable: {
    minWidth: 900
  },
  anchorActionButtons: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1)
  },
  diffList: {
    marginTop: theme.spacing(1)
  },
  diffItem: {
    fontSize: '0.78rem'
  },
  loading: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    padding: theme.spacing(5)
  }
}))

const LEGACY_FREQUENCY_OPTIONS = [
  { value: '', label: 'Unspecified' },
  { value: 'Daily', label: 'Daily' },
  { value: 'Every Other Day (M-W-F)', label: 'Every Other Day (M-W-F)' },
  { value: 'Twice a Week', label: 'Twice a Week' },
  { value: 'Weekly', label: 'Weekly' },
  { value: 'Bi-Weekly', label: 'Bi-Weekly' },
  { value: 'Monthly', label: 'Monthly' },
  { value: 'Quarterly', label: 'Quarterly' },
  { value: 'Semi-Annually', label: 'Semi-Annually' },
  { value: 'Annually', label: 'Annually' },
  { value: 'On Demand', label: 'On Demand' }
]

const DAY_OPTIONS = [
  'Monday',
  'Tuesday',
  'Wednesday',
  'Thursday',
  'Friday'
]

const EVEN_ODD_OPTIONS = [
  { value: '', label: 'No parity' },
  { value: 'Even', label: 'Even Weeks' },
  { value: 'Odd', label: 'Odd Weeks' }
]

const sortDays = (days = []) => {
  return [...new Set(days.filter(Boolean))]
    .sort((a, b) => DAY_OPTIONS.indexOf(a) - DAY_OPTIONS.indexOf(b))
}

const toYmd = (value) => {
  const date = new Date(value)
  if (isNaN(date.getTime())) return ''
  return date.toISOString().slice(0, 10)
}

function RoutingTerritoryPropertiesList ({ url }) {
  const classes = useStyles()
  const history = useHistory()
  const location = useLocation()

  const [scenarios, setScenarios] = useState([])
  const [selectedScenarioId, setSelectedScenarioId] = useState('')
  const [rows, setRows] = useState([])
  const [originalRowsById, setOriginalRowsById] = useState({})
  const [crews, setCrews] = useState([])
  const [loading, setLoading] = useState(true)
  const [loadingScenarios, setLoadingScenarios] = useState(true)
  const [error, setError] = useState(null)
  const [searchText, setSearchText] = useState('')
  const [onlyVip, setOnlyVip] = useState(false)
  const [onlyLocked, setOnlyLocked] = useState(false)
  const [onlyNeedsReview, setOnlyNeedsReview] = useState(false)
  const [page, setPage] = useState(0)
  const [rowsPerPage, setRowsPerPage] = useState(25)
  const [savingBySiteId, setSavingBySiteId] = useState({})
  const [movingBySiteId, setMovingBySiteId] = useState({})
  const [moveTargetBySiteId, setMoveTargetBySiteId] = useState({})
  const [publishingScenario, setPublishingScenario] = useState(false)
  const [lastChangePackage, setLastChangePackage] = useState(null)
  const [scenarioMetrics, setScenarioMetrics] = useState(null)
  const [loadingMetrics, setLoadingMetrics] = useState(false)
  const [scenarioDiff, setScenarioDiff] = useState(null)
  const [loadingDiff, setLoadingDiff] = useState(false)
  const [scenarioCompare, setScenarioCompare] = useState(null)
  const [loadingCompare, setLoadingCompare] = useState(false)
  const [recomputingExact, setRecomputingExact] = useState(false)
  const [exactRecompute, setExactRecompute] = useState(null)
  const [compareToScenarioId, setCompareToScenarioId] = useState('')
  const [compareLevel, setCompareLevel] = useState('fleet')
  const [compareCrewId, setCompareCrewId] = useState('')
  const [compareDate, setCompareDate] = useState(() => new Date().toISOString().slice(0, 10))
  const [anchorCandidates, setAnchorCandidates] = useState([])
  const [anchorCoverage, setAnchorCoverage] = useState(null)
  const [loadingAnchors, setLoadingAnchors] = useState(false)
  const [runningAnchorScoring, setRunningAnchorScoring] = useState(false)
  const [runningCentroids, setRunningCentroids] = useState(false)
  const [savingAnchorByPropertyId, setSavingAnchorByPropertyId] = useState({})
  const [anchorCrewChoiceByPropertyId, setAnchorCrewChoiceByPropertyId] = useState({})
  const [suggestingBySiteId, setSuggestingBySiteId] = useState({})
  const [snackbar, setSnackbar] = useState({ open: false, message: '', severity: 'info' })

  const requestedScenarioId = useMemo(
    () => (new URLSearchParams(location.search).get('scenarioId') || '').trim(),
    [location.search]
  )

  const selectedScenario = useMemo(
    () => scenarios.find(item => item._id === selectedScenarioId) || null,
    [scenarios, selectedScenarioId]
  )
  const isScenarioEditable = selectedScenario?.status === 'draft'
  const crewNameById = useMemo(() => {
    const map = {}
    crews.forEach(crew => {
      map[crew._id] = crew.name
    })
    return map
  }, [crews])

  const downloadChangePackage = useCallback((changePackage) => {
    if (!changePackage?.csv) return false
    const blob = new Blob([changePackage.csv], { type: changePackage.contentType || 'text/csv;charset=utf-8;' })
    const objectUrl = window.URL.createObjectURL(blob)
    const anchor = document.createElement('a')
    anchor.href = objectUrl
    anchor.download = changePackage.fileName || `territory_publish_changes_${Date.now()}.csv`
    document.body.appendChild(anchor)
    anchor.click()
    document.body.removeChild(anchor)
    window.URL.revokeObjectURL(objectUrl)
    return true
  }, [])

  const fetchScenarios = useCallback(async (preferredScenarioId = null) => {
    setLoadingScenarios(true)
    try {
      const response = await axios.get(`${url}/api/hmi/territory/scenarios`)
      const nextScenarios = response.data?.scenarios || []

      setScenarios(nextScenarios)

      if (preferredScenarioId && nextScenarios.some(item => item._id === preferredScenarioId)) {
        setSelectedScenarioId(preferredScenarioId)
      } else {
        setSelectedScenarioId(prev => {
          if (prev && nextScenarios.some(item => item._id === prev)) return prev
          const draft = nextScenarios.find(item => item.status === 'draft')
          return draft?._id || nextScenarios[0]?._id || ''
        })
      }
    } catch (err) {
      console.error('Error loading territory scenarios:', err)
      setError(err.message || 'Failed to load territory scenarios')
    } finally {
      setLoadingScenarios(false)
    }
  }, [url])

  const fetchData = useCallback(async (scenarioId) => {
    setLoading(true)
    setError(null)
    try {
      const response = await axios.get(`${url}/api/hmi/territory/properties`, {
        params: scenarioId ? { scenarioId } : undefined
      })
      const payload = response.data || {}
      const nextRows = payload.properties || []
      const nextCrews = payload.crews || []
      const nextOriginalRowsById = {}

      nextRows.forEach(row => {
        nextOriginalRowsById[row.aspirePropertyId] = {
          lockedCrewId: row.lockedCrewId || '',
          isVip: !!row.isVip,
          frequency: row.frequency || '',
          preferredDay: row.preferredDay || '',
          preferredDays: sortDays(row.preferredDays || []),
          evenOrOddWeeks: row.evenOrOddWeeks || ''
        }
      })

      setRows(nextRows)
      setCrews(nextCrews)
      setOriginalRowsById(nextOriginalRowsById)
      setMoveTargetBySiteId(nextRows.reduce((acc, row) => {
        acc[row.aspirePropertyId] = row.assignedCrewId || ''
        return acc
      }, {}))
    } catch (err) {
      console.error('Error loading territory properties:', err)
      setError(err.message || 'Failed to load territory properties')
    } finally {
      setLoading(false)
    }
  }, [url])

  const fetchScenarioMetrics = useCallback(async (scenarioId) => {
    if (!scenarioId) {
      setScenarioMetrics(null)
      return
    }
    setLoadingMetrics(true)
    try {
      const response = await axios.get(`${url}/api/hmi/territory/scenarios/${scenarioId}/metrics`)
      setScenarioMetrics({
        crews: response.data?.crews || [],
        fleet: response.data?.fleet || null
      })
    } catch (err) {
      console.error('Error loading scenario metrics:', err)
      setSnackbar({
        open: true,
        message: err.response?.data?.message || err.message || 'Failed to load scenario metrics',
        severity: 'error'
      })
      setScenarioMetrics(null)
    } finally {
      setLoadingMetrics(false)
    }
  }, [url])

  const fetchScenarioDiff = useCallback(async (scenarioId, { silentError = false } = {}) => {
    if (!scenarioId) {
      setScenarioDiff(null)
      return null
    }
    setLoadingDiff(true)
    try {
      const response = await axios.get(`${url}/api/hmi/territory/scenarios/${scenarioId}/diff`, {
        params: { includeMetricsDelta: true }
      })
      setScenarioDiff(response.data || null)
      return response.data || null
    } catch (err) {
      console.error('Error loading scenario diff:', err)
      if (!silentError) {
        setSnackbar({
          open: true,
          message: err.response?.data?.message || err.message || 'Failed to load scenario diff',
          severity: 'error'
        })
      }
      setScenarioDiff(null)
      return null
    } finally {
      setLoadingDiff(false)
    }
  }, [url])

  const fetchScenarioCompare = useCallback(async (scenarioId, {
    compareTo = compareToScenarioId,
    level = compareLevel,
    crewId = compareCrewId,
    date = compareDate,
    silentError = false
  } = {}) => {
    if (!scenarioId) {
      setScenarioCompare(null)
      return null
    }

    const params = {
      level: level || 'fleet'
    }
    if (compareTo) params.compareToScenarioId = compareTo
    if (params.level !== 'fleet' && crewId) params.crewId = crewId
    if (params.level === 'crew-day') params.date = date || new Date().toISOString().slice(0, 10)

    setLoadingCompare(true)
    try {
      const response = await axios.get(`${url}/api/hmi/territory/scenarios/${scenarioId}/compare`, { params })
      setScenarioCompare(response.data || null)
      return response.data || null
    } catch (err) {
      console.error('Error loading scenario compare:', err)
      if (!silentError) {
        setSnackbar({
          open: true,
          message: err.response?.data?.message || err.message || 'Failed to load comparison',
          severity: 'error'
        })
      }
      setScenarioCompare(null)
      return null
    } finally {
      setLoadingCompare(false)
    }
  }, [compareCrewId, compareDate, compareLevel, compareToScenarioId, url])

  const runRecomputeExact = useCallback(async () => {
    if (!selectedScenarioId) return

    const body = {}
    if (compareLevel === 'crew-day') {
      if (!compareCrewId) {
        setSnackbar({
          open: true,
          message: 'Pick a crew first for crew-day exact recompute',
          severity: 'warning'
        })
        return
      }
      body.scope = 'day'
      body.crewId = compareCrewId
      body.date = compareDate || new Date().toISOString().slice(0, 10)
    } else if (compareLevel === 'crew-week') {
      if (!compareCrewId) {
        setSnackbar({
          open: true,
          message: 'Pick a crew first for crew-week exact recompute',
          severity: 'warning'
        })
        return
      }
      body.scope = 'week'
      body.crewId = compareCrewId
      body.weekOf = compareDate || new Date().toISOString().slice(0, 10)
    } else {
      body.scope = 'scenario'
      body.weekOf = compareDate || new Date().toISOString().slice(0, 10)
    }

    setRecomputingExact(true)
    try {
      const response = await axios.post(`${url}/api/hmi/territory/scenarios/${selectedScenarioId}/recompute-exact`, body)
      const payload = response.data || null
      setExactRecompute(payload)

      if (body.scope === 'day' && payload?.recompute?.day) {
        const exactDay = payload.recompute.day
        setScenarioCompare(prev => {
          if (!prev?.comparison || prev.comparison.level !== 'crew-day') return prev
          const currentDate = toYmd(prev.comparison.date)
          const targetDate = toYmd(body.date)
          if (String(prev.comparison.crewId || '') !== String(body.crewId || '') || currentDate !== targetDate) {
            return prev
          }

          const baseline = prev.comparison.baseline || {}
          const scenario = {
            ...prev.comparison.scenario,
            stops: Number(exactDay.stops || 0),
            serviceMin: Number(exactDay.serviceMin || 0),
            driveMin: Number(exactDay.driveMin || 0),
            totalMin: Number(exactDay.totalMin || 0),
            otMin: Number(exactDay.otMin || 0),
            mode: exactDay.mode || 'exact'
          }
          const delta = {}
          Object.keys({ ...baseline, ...scenario }).forEach(key => {
            const scenarioValue = Number(scenario[key])
            const baselineValue = Number(baseline[key])
            if (Number.isFinite(scenarioValue) && Number.isFinite(baselineValue)) {
              delta[key] = Math.round((scenarioValue - baselineValue) * 100) / 100
            }
          })

          return {
            ...prev,
            comparison: {
              ...prev.comparison,
              scenario,
              delta
            }
          }
        })
      }

      const summary = payload?.recompute?.summary || payload?.recompute?.fleet || null
      const exactDays = summary?.exactDays || 0
      const estimatedDays = summary?.estimatedDays || 0
      const callsAttempted = summary?.orsCallsAttempted || 0
      const callsSucceeded = summary?.orsCallsSucceeded || 0
      setSnackbar({
        open: true,
        message: `Exact recompute complete (${exactDays} exact / ${estimatedDays} est, ORS ${callsSucceeded}/${callsAttempted})`,
        severity: estimatedDays > 0 ? 'warning' : 'success'
      })
    } catch (err) {
      console.error('Error recomputing exact metrics:', err)
      setSnackbar({
        open: true,
        message: err.response?.data?.message || err.message || 'Failed to recompute exact metrics',
        severity: 'error'
      })
    } finally {
      setRecomputingExact(false)
    }
  }, [compareCrewId, compareDate, compareLevel, selectedScenarioId, url])

  const fetchAnchorCandidates = useCallback(async (scenarioId) => {
    setLoadingAnchors(true)
    try {
      const response = await axios.get(`${url}/api/hmi/territory/anchors/candidates`, {
        params: {
          scenarioId: scenarioId || undefined,
          candidateOnly: true,
          limit: 80
        }
      })
      const nextRows = response.data?.rows || []
      setAnchorCandidates(nextRows)
      setAnchorCoverage(response.data?.coverage || null)
      setAnchorCrewChoiceByPropertyId(nextRows.reduce((acc, item) => {
        const fallbackCrewId = item.anchorCrewId || item.suggestedCrewId || ''
        acc[item.aspirePropertyId] = fallbackCrewId
        return acc
      }, {}))
    } catch (err) {
      console.error('Error loading anchor candidates:', err)
      setSnackbar({
        open: true,
        message: err.response?.data?.message || err.message || 'Failed to load anchor candidates',
        severity: 'error'
      })
      setAnchorCandidates([])
      setAnchorCoverage(null)
    } finally {
      setLoadingAnchors(false)
    }
  }, [url])

  const runAnchorScoring = async () => {
    setRunningAnchorScoring(true)
    try {
      const response = await axios.post(`${url}/api/hmi/territory/compute-anchors`, {}, {
        params: {
          scenarioId: selectedScenarioId || undefined
        }
      })
      const scored = response.data?.scored || 0
      const candidates = response.data?.candidates || 0
      setSnackbar({
        open: true,
        message: `Anchor scoring complete: ${candidates} candidates across ${scored} properties`,
        severity: 'success'
      })
      await fetchAnchorCandidates(selectedScenarioId)
    } catch (err) {
      console.error('Error computing anchors:', err)
      setSnackbar({
        open: true,
        message: err.response?.data?.message || err.message || 'Failed to compute anchors',
        severity: 'error'
      })
    } finally {
      setRunningAnchorScoring(false)
    }
  }

  const runCentroidCompute = async () => {
    setRunningCentroids(true)
    try {
      const response = await axios.post(`${url}/api/hmi/territory/compute-centroids`, {})
      const updatedCount = response.data?.updatedCount || 0
      setSnackbar({
        open: true,
        message: `Crew centroids updated (${updatedCount} crews)`,
        severity: 'success'
      })
      fetchScenarioMetrics(selectedScenarioId)
    } catch (err) {
      console.error('Error computing centroids:', err)
      setSnackbar({
        open: true,
        message: err.response?.data?.message || err.message || 'Failed to compute centroids',
        severity: 'error'
      })
    } finally {
      setRunningCentroids(false)
    }
  }

  const saveAnchor = async (candidate, isAnchor) => {
    const propertyId = candidate?.aspirePropertyId
    if (!propertyId) return

    const selectedCrewId = anchorCrewChoiceByPropertyId[propertyId] || candidate.anchorCrewId || candidate.suggestedCrewId || ''
    if (isAnchor && !selectedCrewId) {
      setSnackbar({
        open: true,
        message: 'Pick a crew before promoting an anchor',
        severity: 'warning'
      })
      return
    }

    setSavingAnchorByPropertyId(prev => ({ ...prev, [propertyId]: true }))
    try {
      const response = await axios.patch(`${url}/api/hmi/territory/anchors/${propertyId}`, {
        isAnchor: !!isAnchor,
        anchorCrewId: isAnchor ? selectedCrewId : null
      })
      const updatedCoverage = response.data?.coverage || null
      if (updatedCoverage) {
        setAnchorCoverage(updatedCoverage)
      }

      setSnackbar({
        open: true,
        message: isAnchor ? 'Anchor updated' : 'Anchor removed',
        severity: 'success'
      })
      await fetchAnchorCandidates(selectedScenarioId)
    } catch (err) {
      console.error('Error saving anchor:', err)
      setSnackbar({
        open: true,
        message: err.response?.data?.message || err.message || 'Failed to save anchor',
        severity: 'error'
      })
    } finally {
      setSavingAnchorByPropertyId(prev => ({ ...prev, [propertyId]: false }))
    }
  }

  const suggestNearestForRow = async (row) => {
    if (!selectedScenarioId || !row?.aspirePropertyId) return

    const propId = row.aspirePropertyId
    setSuggestingBySiteId(prev => ({ ...prev, [propId]: true }))
    try {
      const response = await axios.post(`${url}/api/hmi/territory/scenarios/${selectedScenarioId}/suggest-nearest`, {
        aspirePropertyIds: [propId],
        includeAssigned: true,
        limit: 1
      })
      const suggestion = response.data?.suggestions?.[0]
      if (!suggestion?.suggestedCrewId) {
        setSnackbar({
          open: true,
          message: 'No suggestion available for this property',
          severity: 'info'
        })
        return
      }

      setMoveTargetBySiteId(prev => ({
        ...prev,
        [propId]: suggestion.suggestedCrewId
      }))

      const hasDriveMinutes = Number.isFinite(Number(suggestion.driveMinutes))
      const metricLabel = hasDriveMinutes
        ? `${Math.round(Number(suggestion.driveMinutes))} min`
        : `${suggestion.distanceMiles || 0} mi`
      const methodLabel = suggestion.selectionMethod === 'ors_matrix' ? 'ORS' : 'Haversine'

      setSnackbar({
        open: true,
        message: `Suggested ${suggestion.suggestedCrewName || 'crew'} (${metricLabel}, ${methodLabel})`,
        severity: suggestion.isAmbiguous ? 'warning' : 'success'
      })
    } catch (err) {
      console.error('Error getting nearest-crew suggestion:', err)
      setSnackbar({
        open: true,
        message: err.response?.data?.message || err.message || 'Failed to suggest nearest crew',
        severity: 'error'
      })
    } finally {
      setSuggestingBySiteId(prev => ({ ...prev, [propId]: false }))
    }
  }

  useEffect(() => {
    fetchScenarios(requestedScenarioId || null)
  }, [fetchScenarios, requestedScenarioId])

  useEffect(() => {
    if (!selectedScenarioId) return
    setExactRecompute(null)
    fetchData(selectedScenarioId)
    fetchScenarioMetrics(selectedScenarioId)
    fetchScenarioDiff(selectedScenarioId, { silentError: true })
    fetchAnchorCandidates(selectedScenarioId)
    fetchScenarioCompare(selectedScenarioId, { silentError: true })
  }, [fetchAnchorCandidates, fetchData, fetchScenarioCompare, fetchScenarioDiff, fetchScenarioMetrics, selectedScenarioId])

  useEffect(() => {
    if (selectedScenarioId) return
    setRows([])
    setOriginalRowsById({})
    setScenarioMetrics(null)
    setScenarioDiff(null)
    setScenarioCompare(null)
    setExactRecompute(null)
    setAnchorCandidates([])
    setAnchorCoverage(null)
    setAnchorCrewChoiceByPropertyId({})
    setLoading(false)
  }, [selectedScenarioId])

  useEffect(() => {
    if (compareCrewId) return
    const firstCrew = crews[0]?._id || ''
    if (firstCrew) setCompareCrewId(firstCrew)
  }, [compareCrewId, crews])

  useEffect(() => {
    if (!selectedScenarioId) return
    fetchScenarioCompare(selectedScenarioId, { silentError: true })
  }, [compareCrewId, compareDate, compareLevel, compareToScenarioId, fetchScenarioCompare, selectedScenarioId])

  useEffect(() => {
    if (location.hash !== '#scenario-compare') return
    const target = document.getElementById('scenario-compare')
    if (!target) return
    window.requestAnimationFrame(() => {
      target.scrollIntoView({ behavior: 'smooth', block: 'start' })
    })
  }, [location.hash, selectedScenarioId])

  const filteredRows = useMemo(() => {
    let next = [...rows]

    if (searchText.trim()) {
      const search = searchText.trim().toLowerCase()
      next = next.filter(row => {
        const haystack = [
          row.propertyName,
          row.clientName,
          row.address,
          row.city,
          row.customerType,
          row.frequency,
          row.assignedCrewName,
          row.lockedCrewName
        ]
          .filter(Boolean)
          .join(' ')
          .toLowerCase()
        return haystack.includes(search)
      })
    }

    if (onlyVip) {
      next = next.filter(row => row.isVip)
    }

    if (onlyLocked) {
      next = next.filter(row => !!row.lockedCrewId)
    }

    if (onlyNeedsReview) {
      next = next.filter(row => row.frequencyConfidence === 'needs_review' || row.frequencyCode === 'UNKNOWN')
    }

    return next
  }, [rows, searchText, onlyVip, onlyLocked, onlyNeedsReview])

  const paginatedRows = useMemo(() => {
    return filteredRows.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
  }, [filteredRows, page, rowsPerPage])

  const anchorCoverageLabel = useMemo(() => {
    const missing = anchorCoverage?.missingSectors || []
    if (!anchorCoverage) return 'Coverage: -'
    if (!missing.length) return 'Coverage: complete'
    return `Missing sectors: ${missing.join(', ')}`
  }, [anchorCoverage])

  const compareDeltaChips = useMemo(() => {
    const delta = scenarioCompare?.comparison?.delta || {}
    return Object.entries(delta)
      .filter(([, value]) => typeof value === 'number' && Number.isFinite(value))
      .slice(0, 6)
  }, [scenarioCompare])

  const exactCrewSummaryById = useMemo(() => {
    const map = {}
    const payload = exactRecompute?.recompute
    if (!payload) return map

    if (Array.isArray(payload.crews)) {
      payload.crews.forEach(item => {
        if (item?.crewId) map[item.crewId] = item.summary || null
      })
      return map
    }

    if (payload.crewId && payload.summary) {
      map[payload.crewId] = payload.summary
    }
    return map
  }, [exactRecompute])

  const exactSummary = useMemo(() => {
    const payload = exactRecompute?.recompute || {}
    if (payload.summary) return payload.summary
    if (payload.fleet) return payload.fleet
    return null
  }, [exactRecompute])

  const isRowDirty = useCallback((row) => {
    const original = originalRowsById[row.aspirePropertyId]
    if (!original) return false
    const rowPreferredDays = sortDays(row.preferredDays || [])
    const originalPreferredDays = sortDays(original.preferredDays || [])
    return (row.lockedCrewId || '') !== (original.lockedCrewId || '') ||
      !!row.isVip !== !!original.isVip ||
      (row.frequency || '') !== (original.frequency || '') ||
      (row.preferredDay || '') !== (original.preferredDay || '') ||
      (row.evenOrOddWeeks || '') !== (original.evenOrOddWeeks || '') ||
      rowPreferredDays.join('|') !== originalPreferredDays.join('|')
  }, [originalRowsById])

  const updateRowField = (aspirePropertyId, field, value) => {
    setRows(prev => prev.map(row => {
      if (row.aspirePropertyId !== aspirePropertyId) return row
      return {
        ...row,
        [field]: value
      }
    }))
  }

  const updateLegacyFrequency = (aspirePropertyId, nextFrequency) => {
    setRows(prev => prev.map(row => {
      if (row.aspirePropertyId !== aspirePropertyId) return row
      const updated = {
        ...row,
        frequency: nextFrequency || ''
      }

      if (nextFrequency === 'Every Other Day (M-W-F)') {
        updated.preferredDays = ['Monday', 'Wednesday', 'Friday']
        updated.preferredDay = 'Monday'
        updated.evenOrOddWeeks = ''
      } else if (nextFrequency === 'Twice a Week') {
        if (!Array.isArray(updated.preferredDays) || !updated.preferredDays.length) {
          updated.preferredDays = updated.preferredDay ? [updated.preferredDay] : ['Monday', 'Thursday']
        }
        updated.evenOrOddWeeks = ''
      } else if (nextFrequency === 'Weekly') {
        updated.preferredDay = updated.preferredDay || 'Monday'
        updated.preferredDays = []
        updated.evenOrOddWeeks = ''
      } else if (nextFrequency === 'Bi-Weekly') {
        updated.preferredDay = updated.preferredDay || 'Monday'
        updated.preferredDays = []
      } else {
        updated.evenOrOddWeeks = ''
      }

      return updated
    }))
  }

  const saveRow = async (row) => {
    if (!selectedScenarioId) return
    if (!isRowDirty(row)) return

    setSavingBySiteId(prev => ({ ...prev, [row.aspirePropertyId]: true }))
    try {
      const response = await axios.patch(
        `${url}/api/hmi/territory/properties/${row.aspirePropertyId}`,
        {
          contractId: row.contractId,
          lockedCrewId: row.lockedCrewId || null,
          isVip: !!row.isVip,
          frequency: row.frequency || null,
          preferredDay: row.preferredDay || null,
          preferredDays: sortDays(row.preferredDays || []),
          evenOrOddWeeks: row.evenOrOddWeeks || null
        },
        {
          params: { scenarioId: selectedScenarioId }
        }
      )

      const updated = response.data?.property
      if (updated) {
        setRows(prev => prev.map(item => item.aspirePropertyId === row.aspirePropertyId ? { ...item, ...updated } : item))
        setOriginalRowsById(prev => ({
          ...prev,
          [row.aspirePropertyId]: {
            lockedCrewId: updated.lockedCrewId || '',
            isVip: !!updated.isVip,
            frequency: updated.frequency || '',
            preferredDay: updated.preferredDay || '',
            preferredDays: sortDays(updated.preferredDays || []),
            evenOrOddWeeks: updated.evenOrOddWeeks || ''
          }
        }))
      } else {
        setOriginalRowsById(prev => ({
          ...prev,
          [row.aspirePropertyId]: {
            lockedCrewId: row.lockedCrewId || '',
            isVip: !!row.isVip,
            frequency: row.frequency || '',
            preferredDay: row.preferredDay || '',
            preferredDays: sortDays(row.preferredDays || []),
            evenOrOddWeeks: row.evenOrOddWeeks || ''
          }
        }))
      }

      setSnackbar({ open: true, message: 'Draft updated', severity: 'success' })
      fetchScenarioMetrics(selectedScenarioId)
      fetchScenarioDiff(selectedScenarioId, { silentError: true })
    } catch (err) {
      console.error('Error updating territory property:', err)
      setSnackbar({
        open: true,
        message: err.response?.data?.message || err.message || 'Failed to update property',
        severity: 'error'
      })
    } finally {
      setSavingBySiteId(prev => ({ ...prev, [row.aspirePropertyId]: false }))
    }
  }

  const moveRow = async (row) => {
    if (!selectedScenarioId || !isScenarioEditable) return
    const nextCrewId = moveTargetBySiteId[row.aspirePropertyId] || row.assignedCrewId || ''
    if (!nextCrewId || nextCrewId === row.assignedCrewId) return

    setMovingBySiteId(prev => ({ ...prev, [row.aspirePropertyId]: true }))
    try {
      const response = await axios.post(
        `${url}/api/hmi/territory/scenarios/${selectedScenarioId}/move`,
        {
          aspirePropertyId: row.aspirePropertyId,
          toCrewId: nextCrewId
        }
      )

      const updatedAssignment = response.data?.assignment || null
      setRows(prev => prev.map(item => {
        if (item.aspirePropertyId !== row.aspirePropertyId) return item
        const assignedCrewId = updatedAssignment?.assignedCrewId || nextCrewId
        return {
          ...item,
          assignedCrewId,
          assignedCrewName: crewNameById[assignedCrewId] || 'Unassigned'
        }
      }))

      setMoveTargetBySiteId(prev => ({
        ...prev,
        [row.aspirePropertyId]: nextCrewId
      }))

      setSnackbar({
        open: true,
        message: `Moved ${row.propertyName || `Aspire #${row.aspirePropertyId}`} to ${crewNameById[nextCrewId] || 'selected crew'}`,
        severity: 'success'
      })

      fetchScenarioMetrics(selectedScenarioId)
      fetchScenarioDiff(selectedScenarioId, { silentError: true })
    } catch (err) {
      console.error('Error moving scenario property:', err)
      setSnackbar({
        open: true,
        message: err.response?.data?.message || err.message || 'Failed to move property',
        severity: 'error'
      })
    } finally {
      setMovingBySiteId(prev => ({ ...prev, [row.aspirePropertyId]: false }))
    }
  }

  const refreshAll = useCallback(async () => {
    const activeScenarioId = selectedScenarioId || null
    await fetchScenarios(activeScenarioId)
    if (activeScenarioId) {
      await Promise.all([
        fetchData(activeScenarioId),
        fetchScenarioMetrics(activeScenarioId),
        fetchScenarioDiff(activeScenarioId, { silentError: true }),
        fetchAnchorCandidates(activeScenarioId),
        fetchScenarioCompare(activeScenarioId, { silentError: true })
      ])
    }
  }, [fetchAnchorCandidates, fetchData, fetchScenarioCompare, fetchScenarioDiff, fetchScenarioMetrics, fetchScenarios, selectedScenarioId])

  const createScenario = async () => {
    const typedName = window.prompt('Name for the new simulation draft:', '')
    if (typedName == null) return
    const nextName = typedName.trim() || undefined

    const buildFreshnessMessage = (freshness = {}) => {
      const routingAge = freshness.routingSyncAgeHours == null
        ? 'missing'
        : `${freshness.routingSyncAgeHours}h old`
      const workTicketAge = freshness.workTicketSyncAgeHours == null
        ? 'missing'
        : `${freshness.workTicketSyncAgeHours}h old`
      const reasons = Array.isArray(freshness.staleReasons) && freshness.staleReasons.length
        ? freshness.staleReasons.join(', ')
        : 'unknown'

      return [
        'Scenario data is stale.',
        `Routing sync: ${routingAge}`,
        `Work ticket sync: ${workTicketAge}`,
        `Threshold: ${freshness.freshnessThresholdHours || 6}h`,
        `Reasons: ${reasons}`,
        '',
        'Choose one:',
        '1 = Sync now',
        '2 = Proceed with stale data',
        '3 = Cancel'
      ].join('\n')
    }

    const finalizeScenarioCreate = async (response, staleProceed = false) => {
      const createdId = response.data?.scenario?._id
      await fetchScenarios(createdId)
      if (createdId) {
        await Promise.all([
          fetchData(createdId),
          fetchScenarioMetrics(createdId),
          fetchScenarioDiff(createdId, { silentError: true }),
          fetchAnchorCandidates(createdId),
          fetchScenarioCompare(createdId, { silentError: true })
        ])
      }
      setSnackbar({
        open: true,
        message: staleProceed ? 'Draft scenario created (stale data acknowledged)' : 'Draft scenario created',
        severity: 'success'
      })
    }

    try {
      const basePayload = {
        name: nextName,
        sourceScenarioId: selectedScenarioId || undefined,
        horizonDays: 30
      }
      const response = await axios.post(`${url}/api/hmi/territory/scenarios`, basePayload)
      await finalizeScenarioCreate(response, false)
    } catch (err) {
      if (err.response?.status === 409 && err.response?.data?.requiresFreshnessDecision) {
        const freshness = err.response?.data?.freshness || {}
        const choice = window.prompt(buildFreshnessMessage(freshness), '3')

        if (choice === '1') {
          try {
            await axios.post(`${url}/api/aspire/routing/sync`)
            setSnackbar({
              open: true,
              message: 'Aspire routing sync started. Wait a few minutes, then create the scenario again.',
              severity: 'info'
            })
          } catch (syncErr) {
            console.error('Error starting Aspire routing sync:', syncErr)
            setSnackbar({
              open: true,
              message: syncErr.response?.data?.message || syncErr.message || 'Failed to start sync',
              severity: 'error'
            })
          }
          return
        }

        if (choice === '2') {
          try {
            const retryResponse = await axios.post(`${url}/api/hmi/territory/scenarios`, {
              name: nextName,
              sourceScenarioId: selectedScenarioId || undefined,
              horizonDays: 30,
              proceedWithStaleData: true
            })
            await finalizeScenarioCreate(retryResponse, true)
          } catch (retryErr) {
            console.error('Error creating scenario with stale acknowledgment:', retryErr)
            setSnackbar({
              open: true,
              message: retryErr.response?.data?.message || retryErr.message || 'Failed to create scenario',
              severity: 'error'
            })
          }
          return
        }

        setSnackbar({
          open: true,
          message: 'Scenario creation cancelled',
          severity: 'info'
        })
        return
      }

      console.error('Error creating territory scenario:', err)
      setSnackbar({
        open: true,
        message: err.response?.data?.message || err.message || 'Failed to create scenario',
        severity: 'error'
      })
    }
  }

  const publishScenario = async () => {
    if (!selectedScenarioId || !selectedScenario || selectedScenario.status !== 'draft') return

    const diffPayload = await fetchScenarioDiff(selectedScenarioId)
    if (!diffPayload) return

    const summary = diffPayload?.diff?.summary || {}
    const metricsDelta = diffPayload?.metricsDelta || null
    const confirmMessageLines = [
      `Publish "${selectedScenario.name}" to live routing data?`,
      '',
      `Moved properties: ${summary.movedCount || 0}`,
      `VIP changes: ${summary.vipChangedCount || 0}`,
      `Lock changes: ${summary.lockChangedCount || 0}`
    ]
    if (metricsDelta) {
      confirmMessageLines.push('')
      confirmMessageLines.push(`Delta OT minutes: ${Math.round(metricsDelta.totalOTMinutesDelta || 0)}`)
      confirmMessageLines.push(`Delta avg crew load: ${Math.round(metricsDelta.avgCrewLoadDelta || 0)} min`)
    }
    const confirmed = window.confirm(confirmMessageLines.join('\n'))
    if (!confirmed) return

    setPublishingScenario(true)
    try {
      const response = await axios.post(`${url}/api/hmi/territory/scenarios/${selectedScenarioId}/publish`)
      const changePackage = response.data?.changePackage || null
      const downloaded = downloadChangePackage(changePackage)
      if (downloaded) {
        setLastChangePackage(changePackage)
      } else {
        setLastChangePackage(null)
      }
      await fetchScenarios(selectedScenarioId)
      await Promise.all([
        fetchData(selectedScenarioId),
        fetchScenarioMetrics(selectedScenarioId),
        fetchScenarioDiff(selectedScenarioId, { silentError: true }),
        fetchAnchorCandidates(selectedScenarioId),
        fetchScenarioCompare(selectedScenarioId, { silentError: true })
      ])
      setSnackbar({
        open: true,
        message: downloaded
          ? `Scenario published and CSV downloaded (${changePackage.rowCount || 0} changes)`
          : 'Scenario published to live data',
        severity: 'success'
      })
    } catch (err) {
      console.error('Error publishing territory scenario:', err)
      setSnackbar({
        open: true,
        message: err.response?.data?.message || err.message || 'Failed to publish scenario',
        severity: 'error'
      })
    } finally {
      setPublishingScenario(false)
    }
  }

  if (loading || loadingScenarios) {
    return (
      <div className={classes.loading}>
        <CircularProgress />
      </div>
    )
  }

  if (error) {
    return (
      <Paper className={classes.paper}>
        <Box p={3}>
          <Typography color="error">Error: {error}</Typography>
          <Box mt={2}>
            <Button variant="outlined" startIcon={<RefreshIcon />} onClick={refreshAll}>
              Retry
            </Button>
          </Box>
        </Box>
      </Paper>
    )
  }

  return (
    <div className={classes.root}>
      <Paper className={classes.paper}>
        <Toolbar className={classes.toolbar}>
          <Button
            variant="outlined"
            startIcon={<ArrowBackIcon />}
            onClick={() => history.push('/routing/territory/dashboard')}
          >
            Back
          </Button>
          <Typography variant="h5">Territory Locks + VIP</Typography>
          <Select
            value={selectedScenarioId || ''}
            onChange={(event) => setSelectedScenarioId(event.target.value)}
            variant="outlined"
            size="small"
            displayEmpty
          >
            <MenuItem value="" disabled>Select scenario</MenuItem>
            {scenarios.map(item => (
              <MenuItem key={item._id} value={item._id}>
                {item.name} ({item.status}{item.isStaleAtCreation ? ', stale' : ''})
              </MenuItem>
            ))}
          </Select>
          <Button variant="outlined" size="small" onClick={createScenario}>
            New Draft
          </Button>
          <Button
            variant="contained"
            color="secondary"
            size="small"
            disabled={!selectedScenarioId || !isScenarioEditable || publishingScenario}
            onClick={publishScenario}
          >
            {publishingScenario ? 'Publishing...' : 'Publish'}
          </Button>
          <Button
            variant="outlined"
            size="small"
            startIcon={<GetAppIcon />}
            disabled={!lastChangePackage?.csv}
            onClick={() => {
              downloadChangePackage(lastChangePackage)
            }}
          >
            Download Last Change CSV
          </Button>
          {selectedScenario && (
            <Chip
              className={classes.statChip}
              size="small"
              label={`${selectedScenario.status.toUpperCase()}${selectedScenario.assignmentCount != null ? ` • ${selectedScenario.assignmentCount} overrides` : ''}`}
            />
          )}
          {selectedScenario?.isStaleAtCreation && (
            <Chip
              className={classes.statChip}
              size="small"
              color="secondary"
              label="Created from stale sync"
            />
          )}
          <Chip className={classes.statChip} label={`${filteredRows.length} properties`} size="small" />
          <Chip className={classes.statChip} label={`${filteredRows.filter(r => r.isVip).length} VIP`} size="small" />
          <Chip className={classes.statChip} label={`${filteredRows.filter(r => !!r.lockedCrewId).length} locked`} size="small" />
          <TextField
            className={classes.search}
            variant="outlined"
            size="small"
            placeholder="Search properties..."
            value={searchText}
            onChange={(event) => {
              setSearchText(event.target.value)
              setPage(0)
            }}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon />
                </InputAdornment>
              )
            }}
          />
          <FormControlLabel
            control={<Switch checked={onlyVip} onChange={(event) => { setOnlyVip(event.target.checked); setPage(0) }} />}
            label="VIP only"
          />
          <FormControlLabel
            control={<Switch checked={onlyLocked} onChange={(event) => { setOnlyLocked(event.target.checked); setPage(0) }} />}
            label="Locked only"
          />
          <FormControlLabel
            control={<Switch checked={onlyNeedsReview} onChange={(event) => { setOnlyNeedsReview(event.target.checked); setPage(0) }} />}
            label="Needs review only"
          />
          <IconButton onClick={refreshAll}>
            <RefreshIcon />
          </IconButton>
        </Toolbar>

        <div className={classes.metricsSection}>
          <Paper variant="outlined" className={classes.metricsPanel}>
            <div className={classes.metricsHeader}>
              <Typography variant="subtitle1">Scenario Metrics</Typography>
              {loadingMetrics && <CircularProgress size={16} />}
            </div>
            {!loadingMetrics && scenarioMetrics?.fleet && (
              <div className={classes.metricsChips}>
                <Chip size="small" label={`Crews: ${scenarioMetrics.fleet.crewCount || 0}`} />
                <Chip size="small" label={`Properties: ${scenarioMetrics.fleet.totalProperties || 0}`} />
                <Chip size="small" label={`VIP: ${scenarioMetrics.fleet.totalVip || 0}`} />
                <Chip size="small" label={`Avg Load (min): ${scenarioMetrics.fleet.avgCrewLoad || 0}`} />
                <Chip size="small" label={`Max/Min (min): ${scenarioMetrics.fleet.maxCrewLoad || 0}/${scenarioMetrics.fleet.minCrewLoad || 0}`} />
                <Chip size="small" label={`OT (hrs): ${((scenarioMetrics.fleet.totalOTMinutes || 0) / 60).toFixed(1)}`} />
              </div>
            )}
            {!!exactRecompute && !!exactSummary && (
              <div className={classes.metricsChips}>
                <Chip size="small" variant="outlined" label={`Exact scope: ${exactRecompute.scope || 'scenario'}`} />
                <Chip size="small" variant="outlined" label={`Exact days: ${exactSummary.exactDays || 0}`} />
                <Chip size="small" variant="outlined" label={`Estimated days: ${exactSummary.estimatedDays || 0}`} />
                <Chip size="small" variant="outlined" label={`ORS calls: ${exactSummary.orsCallsSucceeded || 0}/${exactSummary.orsCallsAttempted || 0}`} />
                {Number(exactSummary.missingCoordinates || 0) > 0 && (
                  <Chip size="small" variant="outlined" label={`Missing coords: ${exactSummary.missingCoordinates || 0}`} />
                )}
              </div>
            )}
            {!loadingMetrics && Array.isArray(scenarioMetrics?.crews) && (
              <div className={classes.tableWrapper}>
                <Table className={classes.metricsTable} size="small">
                  <TableHead>
                    <TableRow>
                      <TableCell className={`${classes.tableCell} ${classes.headerCell}`}>Crew</TableCell>
                      <TableCell className={`${classes.tableCell} ${classes.headerCell}`}>Exactness</TableCell>
                      <TableCell className={`${classes.tableCell} ${classes.headerCell}`}>Props</TableCell>
                      <TableCell className={`${classes.tableCell} ${classes.headerCell}`}>VIP</TableCell>
                      <TableCell className={`${classes.tableCell} ${classes.headerCell}`}>Service (min/wk)</TableCell>
                      <TableCell className={`${classes.tableCell} ${classes.headerCell}`}>Drive (min/wk)</TableCell>
                      <TableCell className={`${classes.tableCell} ${classes.headerCell}`}>Total (min/wk)</TableCell>
                      <TableCell className={`${classes.tableCell} ${classes.headerCell}`}>OT (min/wk)</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {(scenarioMetrics.crews || [])
                      .filter(item => item.crewId !== 'unassigned')
                      .sort((a, b) => Number(b.weeklyTotalMinutes || 0) - Number(a.weeklyTotalMinutes || 0))
                      .slice(0, 8)
                      .map(item => {
                        const exactRowSummary = exactCrewSummaryById[item.crewId] || null
                        const hasExactness = !!exactRowSummary
                        return (
                          <TableRow key={item.crewId}>
                            <TableCell className={classes.tableCell}>{item.crewName}</TableCell>
                            <TableCell className={classes.tableCell}>
                              {hasExactness
                                ? (
                                  <Chip
                                    size="small"
                                    variant="outlined"
                                    label={`Exact ${exactRowSummary.exactDays || 0} / Est ${exactRowSummary.estimatedDays || 0}`}
                                  />
                                  )
                                : '—'}
                            </TableCell>
                            <TableCell className={classes.tableCell}>{item.propertyCount || 0}</TableCell>
                            <TableCell className={classes.tableCell}>{item.vipCount || 0}</TableCell>
                            <TableCell className={classes.tableCell}>{item.weeklyServiceMinutes || 0}</TableCell>
                            <TableCell className={classes.tableCell}>{item.estimatedWeeklyDriveMinutes || 0}</TableCell>
                            <TableCell className={classes.tableCell}>{item.weeklyTotalMinutes || 0}</TableCell>
                            <TableCell className={classes.tableCell}>{item.estimatedWeeklyOTMinutes || 0}</TableCell>
                          </TableRow>
                        )
                      })}
                  </TableBody>
                </Table>
              </div>
            )}
          </Paper>

          <Paper id="scenario-diff" variant="outlined" className={classes.diffPanel}>
            <div className={classes.metricsHeader}>
              <Typography variant="subtitle1">Scenario Diff (vs published)</Typography>
              <Box display="flex" alignItems="center" style={{ gap: 8 }}>
                {loadingDiff && <CircularProgress size={16} />}
                <Button
                  variant="outlined"
                  size="small"
                  disabled={!selectedScenarioId || loadingDiff}
                  onClick={() => fetchScenarioDiff(selectedScenarioId)}
                >
                  Refresh Diff
                </Button>
              </Box>
            </div>
            {scenarioDiff?.diff?.summary && (
              <div className={classes.metricsChips}>
                <Chip size="small" label={`Moved: ${scenarioDiff.diff.summary.movedCount || 0}`} />
                <Chip size="small" label={`VIP changed: ${scenarioDiff.diff.summary.vipChangedCount || 0}`} />
                <Chip size="small" label={`Locks changed: ${scenarioDiff.diff.summary.lockChangedCount || 0}`} />
              </div>
            )}
            {scenarioDiff?.metricsDelta && (
              <div className={classes.metricsChips}>
                <Chip size="small" label={`Delta OT (min): ${Math.round(scenarioDiff.metricsDelta.totalOTMinutesDelta || 0)}`} />
                <Chip size="small" label={`Delta avg load (min): ${Math.round(scenarioDiff.metricsDelta.avgCrewLoadDelta || 0)}`} />
                <Chip size="small" label={`Delta max load (min): ${Math.round(scenarioDiff.metricsDelta.maxCrewLoadDelta || 0)}`} />
              </div>
            )}
            {!loadingDiff && scenarioDiff?.diff?.moved?.length > 0 && (
              <div className={classes.diffList}>
                <Typography variant="body2"><strong>Top moved properties</strong></Typography>
                {(scenarioDiff.diff.moved || []).slice(0, 8).map(item => (
                  <Typography key={item.aspirePropertyId} className={classes.diffItem}>
                    Aspire #{item.aspirePropertyId}: {item.fromCrewName || 'Unassigned'} → {item.toCrewName || 'Unassigned'}
                  </Typography>
                ))}
              </div>
            )}
            {!loadingDiff && !scenarioDiff?.diff?.summary && (
              <Typography variant="body2" color="textSecondary">
                No diff loaded yet.
              </Typography>
            )}
          </Paper>

          <Paper id="scenario-compare" variant="outlined" className={classes.diffPanel}>
            <div className={classes.metricsHeader}>
              <Typography variant="subtitle1">Scenario Compare</Typography>
              <Box display="flex" alignItems="center" style={{ gap: 8 }}>
                {(loadingCompare || recomputingExact) && <CircularProgress size={16} />}
                <Select
                  value={compareToScenarioId}
                  onChange={(event) => setCompareToScenarioId(event.target.value)}
                  variant="outlined"
                  size="small"
                  displayEmpty
                >
                  <MenuItem value="">Published (live)</MenuItem>
                  {scenarios
                    .filter(item => item._id !== selectedScenarioId)
                    .map(item => (
                      <MenuItem key={item._id} value={item._id}>{item.name}</MenuItem>
                    ))}
                </Select>
                <Select
                  value={compareLevel}
                  onChange={(event) => setCompareLevel(event.target.value)}
                  variant="outlined"
                  size="small"
                >
                  <MenuItem value="fleet">Fleet</MenuItem>
                  <MenuItem value="crew-week">Crew Week</MenuItem>
                  <MenuItem value="crew-day">Crew Day (est.)</MenuItem>
                </Select>
                {compareLevel !== 'fleet' && (
                  <Select
                    value={compareCrewId}
                    onChange={(event) => setCompareCrewId(event.target.value)}
                    variant="outlined"
                    size="small"
                    displayEmpty
                  >
                    <MenuItem value="" disabled>Select crew</MenuItem>
                    {crews.map(crew => (
                      <MenuItem key={crew._id} value={crew._id}>{crew.name}</MenuItem>
                    ))}
                  </Select>
                )}
                {compareLevel === 'crew-day' && (
                  <TextField
                    type="date"
                    value={compareDate}
                    onChange={(event) => setCompareDate(event.target.value)}
                    variant="outlined"
                    size="small"
                    InputLabelProps={{ shrink: true }}
                  />
                )}
                <Button
                  variant="outlined"
                  size="small"
                  disabled={!selectedScenarioId || loadingCompare || recomputingExact}
                  onClick={runRecomputeExact}
                >
                  Recompute Exact
                </Button>
                <Button
                  variant="outlined"
                  size="small"
                  disabled={!selectedScenarioId || loadingCompare}
                  onClick={() => fetchScenarioCompare(selectedScenarioId)}
                >
                  Refresh Compare
                </Button>
              </Box>
            </div>
            {scenarioCompare?.comparison && (
              <div className={classes.metricsChips}>
                <Chip
                  size="small"
                  label={`Level: ${scenarioCompare.comparison.level}`}
                />
                <Chip
                  size="small"
                  label={`Baseline: ${scenarioCompare.compareTo?.name || 'Published (live)'}`}
                />
                {scenarioCompare.comparison.crewName && (
                  <Chip size="small" label={`Crew: ${scenarioCompare.comparison.crewName}`} />
                )}
              </div>
            )}
            {scenarioCompare?.comparison?.baseline && scenarioCompare?.comparison?.scenario && (
              <div className={classes.metricsChips}>
                <Chip
                  size="small"
                  label={`Scenario total: ${scenarioCompare.comparison.scenario.totalMin || scenarioCompare.comparison.scenario.avgCrewLoad || 0}`}
                />
                <Chip
                  size="small"
                  label={`Baseline total: ${scenarioCompare.comparison.baseline.totalMin || scenarioCompare.comparison.baseline.avgCrewLoad || 0}`}
                />
              </div>
            )}
            {scenarioCompare?.comparison?.level === 'crew-day' && (
              <div className={classes.metricsChips}>
                <Chip
                  size="small"
                  variant="outlined"
                  label={`Scenario mode: ${scenarioCompare?.comparison?.scenario?.mode || 'estimated'}`}
                />
                <Chip
                  size="small"
                  variant="outlined"
                  label={`Baseline mode: ${scenarioCompare?.comparison?.baseline?.mode || 'estimated'}`}
                />
              </div>
            )}
            {compareDeltaChips.length > 0 && (
              <div className={classes.metricsChips}>
                {compareDeltaChips.map(([key, value]) => (
                  <Chip
                    key={key}
                    size="small"
                    label={`Delta ${key}: ${Math.round(value)}`}
                  />
                ))}
              </div>
            )}
            {!!exactRecompute?.recompute && (
              <div className={classes.metricsChips}>
                <Chip size="small" variant="outlined" label={`Last exact scope: ${exactRecompute.scope || 'scenario'}`} />
                {exactRecompute?.recompute?.day?.mode && (
                  <Chip size="small" variant="outlined" label={`Last exact day mode: ${exactRecompute.recompute.day.mode}`} />
                )}
                {!!exactSummary && (
                  <Chip
                    size="small"
                    variant="outlined"
                    label={`Last exact/est: ${exactSummary.exactDays || 0}/${exactSummary.estimatedDays || 0}`}
                  />
                )}
                {!!exactSummary && (
                  <Chip
                    size="small"
                    variant="outlined"
                    label={`Last ORS calls: ${exactSummary.orsCallsSucceeded || 0}/${exactSummary.orsCallsAttempted || 0}`}
                  />
                )}
                {!!exactRecompute?.recompute?.day?.fallbackReason && (
                  <Chip
                    size="small"
                    variant="outlined"
                    label={`Fallback: ${exactRecompute.recompute.day.fallbackReason}`}
                  />
                )}
              </div>
            )}
            {!loadingCompare && !scenarioCompare?.comparison && (
              <Typography variant="body2" color="textSecondary">
                No comparison loaded yet.
              </Typography>
            )}
          </Paper>

          <Paper variant="outlined" className={classes.anchorPanel}>
            <div className={classes.metricsHeader}>
              <Typography variant="subtitle1">Anchor Candidates</Typography>
              <Box display="flex" alignItems="center" style={{ gap: 8 }}>
                {(loadingAnchors || runningAnchorScoring || runningCentroids) && <CircularProgress size={16} />}
                <Button
                  variant="outlined"
                  size="small"
                  disabled={runningAnchorScoring}
                  onClick={runAnchorScoring}
                >
                  {runningAnchorScoring ? 'Scoring...' : 'Score Candidates'}
                </Button>
                <Button
                  variant="outlined"
                  size="small"
                  disabled={runningCentroids}
                  onClick={runCentroidCompute}
                >
                  {runningCentroids ? 'Computing...' : 'Recompute Centroids'}
                </Button>
                <Button
                  variant="outlined"
                  size="small"
                  disabled={loadingAnchors}
                  onClick={() => fetchAnchorCandidates(selectedScenarioId)}
                >
                  Refresh Anchors
                </Button>
              </Box>
            </div>

            <div className={classes.metricsChips}>
              <Chip size="small" label={`Candidates: ${anchorCandidates.length}`} />
              <Chip size="small" label={`Anchors: ${anchorCoverage?.anchorCount || 0}`} />
              <Chip size="small" label={`Anchors w/coords: ${anchorCoverage?.anchorsWithCoordinates || 0}`} />
              <Chip size="small" label={anchorCoverageLabel} color={anchorCoverage?.isComplete ? 'primary' : 'secondary'} />
            </div>

            {anchorCoverage && !anchorCoverage.isComplete && (
              <Alert severity="warning">
                Geographic coverage gap detected: {anchorCoverage.missingSectors.join(', ')}.
              </Alert>
            )}

            <div className={classes.tableWrapper}>
              <Table className={classes.anchorTable} size="small">
                <TableHead>
                  <TableRow>
                    <TableCell className={`${classes.tableCell} ${classes.headerCell}`}>Property</TableCell>
                    <TableCell className={`${classes.tableCell} ${classes.headerCell}`}>Score</TableCell>
                    <TableCell className={`${classes.tableCell} ${classes.headerCell}`}>Reasons</TableCell>
                    <TableCell className={`${classes.tableCell} ${classes.headerCell}`}>Suggested Crew</TableCell>
                    <TableCell className={`${classes.tableCell} ${classes.headerCell}`}>Anchor Crew</TableCell>
                    <TableCell className={`${classes.tableCell} ${classes.headerCell}`}>Action</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {(anchorCandidates || []).slice(0, 30).map(item => {
                    const anchorChoice = anchorCrewChoiceByPropertyId[item.aspirePropertyId] || item.anchorCrewId || item.suggestedCrewId || ''
                    const savingAnchor = !!savingAnchorByPropertyId[item.aspirePropertyId]
                    return (
                      <TableRow key={item.aspirePropertyId}>
                        <TableCell className={classes.tableCell}>
                          <Typography variant="body2">{item.propertyName}</Typography>
                          <Typography className={classes.addressText}>
                            Aspire #{item.aspirePropertyId}
                            {item.isAnchor ? ' • Active anchor' : ''}
                          </Typography>
                        </TableCell>
                        <TableCell className={classes.tableCell}>{Math.round(item.anchorScore || 0)}</TableCell>
                        <TableCell className={classes.tableCell}>
                          {(item.anchorReason || []).length
                            ? (item.anchorReason || []).join(', ')
                            : '-'}
                        </TableCell>
                        <TableCell className={classes.tableCell}>{item.suggestedCrewName || '—'}</TableCell>
                        <TableCell className={classes.tableCell}>
                          <Select
                            value={anchorChoice}
                            onChange={(event) => {
                              const nextCrewId = event.target.value
                              setAnchorCrewChoiceByPropertyId(prev => ({
                                ...prev,
                                [item.aspirePropertyId]: nextCrewId
                              }))
                            }}
                            variant="outlined"
                            size="small"
                            className={classes.moveControl}
                            disabled={savingAnchor}
                          >
                            <MenuItem value="" disabled>Select crew</MenuItem>
                            {crews.map(crew => (
                              <MenuItem key={crew._id} value={crew._id}>{crew.name}</MenuItem>
                            ))}
                          </Select>
                        </TableCell>
                        <TableCell className={classes.tableCell}>
                          <div className={classes.anchorActionButtons}>
                            <Button
                              variant="outlined"
                              color="primary"
                              size="small"
                              disabled={savingAnchor || !anchorChoice}
                              onClick={() => saveAnchor(item, true)}
                            >
                              {savingAnchor ? 'Saving...' : (item.isAnchor ? 'Update' : 'Promote')}
                            </Button>
                            {item.isAnchor && (
                              <Button
                                variant="outlined"
                                size="small"
                                disabled={savingAnchor}
                                onClick={() => saveAnchor(item, false)}
                              >
                                Demote
                              </Button>
                            )}
                          </div>
                        </TableCell>
                      </TableRow>
                    )
                  })}
                  {!loadingAnchors && (!anchorCandidates || anchorCandidates.length === 0) && (
                    <TableRow>
                      <TableCell colSpan={6} align="center">
                        <Typography color="textSecondary">No anchor candidates available</Typography>
                      </TableCell>
                    </TableRow>
                  )}
                </TableBody>
              </Table>
            </div>
          </Paper>
        </div>

        <div className={classes.tableWrapper}>
          <Table className={classes.table} size="small">
            <TableHead>
              <TableRow>
                <TableCell className={`${classes.tableCell} ${classes.headerCell}`}>Property</TableCell>
                <TableCell className={`${classes.tableCell} ${classes.headerCell}`}>Link Status</TableCell>
                <TableCell className={`${classes.tableCell} ${classes.headerCell}`}>Customer Type</TableCell>
                <TableCell className={`${classes.tableCell} ${classes.headerCell}`}>Frequency</TableCell>
                <TableCell className={`${classes.tableCell} ${classes.headerCell}`}>Schedule Edit</TableCell>
                <TableCell className={`${classes.tableCell} ${classes.headerCell}`}>Assigned Crew</TableCell>
                <TableCell className={`${classes.tableCell} ${classes.headerCell}`}>Move To Crew</TableCell>
                <TableCell className={`${classes.tableCell} ${classes.headerCell}`}>Locked Crew</TableCell>
                <TableCell className={`${classes.tableCell} ${classes.headerCell}`}>VIP</TableCell>
                <TableCell className={`${classes.tableCell} ${classes.headerCell}`}>Actions</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {paginatedRows.map(row => {
                const dirty = isRowDirty(row)
                const isSaving = !!savingBySiteId[row.aspirePropertyId]
                const isMoving = !!movingBySiteId[row.aspirePropertyId]
                const isSuggesting = !!suggestingBySiteId[row.aspirePropertyId]
                const moveTargetCrewId = moveTargetBySiteId[row.aspirePropertyId] || row.assignedCrewId || ''
                const canMove = isScenarioEditable && moveTargetCrewId && moveTargetCrewId !== row.assignedCrewId && !isMoving
                const linkStatusLabel = row.linkStatus === 'agreement_linked'
                  ? 'Agreement'
                  : (row.linkStatus === 'jobsite_only' ? 'Jobsite only' : 'Unmapped')

                return (
                  <TableRow key={row.aspirePropertyId} hover>
                    <TableCell className={`${classes.tableCell} ${classes.nameCell}`}>
                      <Typography variant="body2">{row.propertyName || '-'}</Typography>
                      <Typography className={classes.addressText}>
                        {[
                          `Aspire #${row.aspirePropertyId}`,
                          row.clientName,
                          row.address,
                          row.city
                        ].filter(Boolean).join(' - ') || '-'}
                      </Typography>
                    </TableCell>
                    <TableCell className={classes.tableCell}>
                      <Chip
                        size="small"
                        label={linkStatusLabel}
                        color={row.linkStatus === 'agreement_linked' ? 'primary' : 'default'}
                      />
                    </TableCell>
                    <TableCell className={classes.tableCell}>{row.customerType || '-'}</TableCell>
                    <TableCell className={classes.tableCell}>
                      <Box display="flex" flexDirection="column" style={{ gap: 4 }}>
                        <Typography variant="body2">{row.frequency || 'Unspecified'}</Typography>
                        {row.preferredDay && (
                          <Typography className={classes.addressText}>Day: {row.preferredDay}</Typography>
                        )}
                        {Array.isArray(row.preferredDays) && row.preferredDays.length > 0 && (
                          <Typography className={classes.addressText}>
                            Days: {sortDays(row.preferredDays).join(', ')}
                          </Typography>
                        )}
                        {row.evenOrOddWeeks && (
                          <Typography className={classes.addressText}>Weeks: {row.evenOrOddWeeks}</Typography>
                        )}
                        <Box display="flex" alignItems="center" style={{ gap: 6, flexWrap: 'wrap' }}>
                          {(row.frequencyConfidence === 'needs_review' || row.frequencyCode === 'UNKNOWN') && (
                            <Chip size="small" color="secondary" label="Needs review" />
                          )}
                        </Box>
                      </Box>
                    </TableCell>
                    <TableCell className={`${classes.tableCell} ${classes.controlsCell}`}>
                      <Box display="flex" alignItems="center" style={{ gap: 8, flexWrap: 'wrap' }}>
                        <Select
                          value={row.frequency || ''}
                          onChange={(event) => updateLegacyFrequency(row.aspirePropertyId, event.target.value)}
                          variant="outlined"
                          size="small"
                          className={classes.freqFixControlWide}
                          disabled={!isScenarioEditable}
                        >
                          {LEGACY_FREQUENCY_OPTIONS.map(option => (
                            <MenuItem key={option.value || 'unspecified'} value={option.value}>{option.label}</MenuItem>
                          ))}
                        </Select>
                        {(row.frequency === 'Weekly' || row.frequency === 'Bi-Weekly') && (
                          <Select
                            value={row.preferredDay || ''}
                            onChange={(event) => updateRowField(row.aspirePropertyId, 'preferredDay', event.target.value)}
                            variant="outlined"
                            size="small"
                            className={classes.freqFixControl}
                            disabled={!isScenarioEditable}
                          >
                            <MenuItem value="">No day</MenuItem>
                            {DAY_OPTIONS.map(day => (
                              <MenuItem key={day} value={day}>{day}</MenuItem>
                            ))}
                          </Select>
                        )}
                        {row.frequency === 'Twice a Week' && (
                          <Select
                            multiple
                            value={sortDays(row.preferredDays || [])}
                            onChange={(event) => {
                              const incoming = Array.isArray(event.target.value)
                                ? event.target.value
                                : String(event.target.value || '').split(',')
                              const next = sortDays(incoming).slice(0, 2)
                              updateRowField(row.aspirePropertyId, 'preferredDays', next)
                              if (!row.preferredDay && next[0]) {
                                updateRowField(row.aspirePropertyId, 'preferredDay', next[0])
                              }
                            }}
                            variant="outlined"
                            size="small"
                            className={classes.freqFixControlWide}
                            disabled={!isScenarioEditable}
                            renderValue={(selected) => (selected || []).join(', ') || 'No days'}
                          >
                            {DAY_OPTIONS.map(day => (
                              <MenuItem key={day} value={day}>{day}</MenuItem>
                            ))}
                          </Select>
                        )}
                        {row.frequency === 'Bi-Weekly' && (
                          <Select
                            value={row.evenOrOddWeeks || ''}
                            onChange={(event) => updateRowField(row.aspirePropertyId, 'evenOrOddWeeks', event.target.value)}
                            variant="outlined"
                            size="small"
                            className={classes.freqFixControl}
                            disabled={!isScenarioEditable}
                          >
                            {EVEN_ODD_OPTIONS.map(option => (
                              <MenuItem key={option.value || 'none'} value={option.value}>{option.label}</MenuItem>
                            ))}
                          </Select>
                        )}
                      </Box>
                    </TableCell>
                    <TableCell className={classes.tableCell}>{row.assignedCrewName || 'Unassigned'}</TableCell>
                    <TableCell className={classes.tableCell}>
                      <Box display="flex" alignItems="center">
                        <Select
                          value={moveTargetCrewId}
                          onChange={(event) => {
                            const nextCrewId = event.target.value
                            setMoveTargetBySiteId(prev => ({
                              ...prev,
                              [row.aspirePropertyId]: nextCrewId
                            }))
                          }}
                          variant="outlined"
                          size="small"
                          className={classes.moveControl}
                          disabled={!isScenarioEditable || isMoving}
                        >
                          <MenuItem value="" disabled>
                            Select crew
                          </MenuItem>
                          {crews.map(crew => (
                            <MenuItem key={crew._id} value={crew._id}>{crew.name}</MenuItem>
                          ))}
                        </Select>
                        <Button
                          className={classes.moveButton}
                          variant="outlined"
                          color="primary"
                          size="small"
                          disabled={!canMove}
                          onClick={() => moveRow(row)}
                        >
                          {isMoving ? 'Moving' : 'Move'}
                        </Button>
                        <Button
                          className={classes.moveButton}
                          variant="outlined"
                          size="small"
                          disabled={!isScenarioEditable || isSuggesting}
                          onClick={() => suggestNearestForRow(row)}
                        >
                          {isSuggesting ? 'Suggesting' : 'Suggest'}
                        </Button>
                      </Box>
                    </TableCell>
                    <TableCell className={`${classes.tableCell} ${classes.controlsCell}`}>
                      <Select
                        value={row.lockedCrewId || ''}
                        onChange={(event) => updateRowField(row.aspirePropertyId, 'lockedCrewId', event.target.value)}
                        variant="outlined"
                        size="small"
                        fullWidth
                        disabled={!isScenarioEditable}
                      >
                        <MenuItem value="">Unlocked</MenuItem>
                        {crews.map(crew => (
                          <MenuItem key={crew._id} value={crew._id}>{crew.name}</MenuItem>
                        ))}
                      </Select>
                    </TableCell>
                    <TableCell className={classes.tableCell}>
                      <Box display="flex" alignItems="center" gap={1}>
                        <Switch
                          checked={!!row.isVip}
                          onChange={(event) => updateRowField(row.aspirePropertyId, 'isVip', event.target.checked)}
                          color="secondary"
                          disabled={!isScenarioEditable}
                        />
                        {!row.isVip && row.autoVipSuggested && (
                          <Chip size="small" color="default" label="Auto suggest" />
                        )}
                      </Box>
                    </TableCell>
                    <TableCell className={classes.tableCell}>
                      <Button
                        className={classes.saveButton}
                        variant="contained"
                        color="primary"
                        size="small"
                        startIcon={isSaving ? <CircularProgress size={14} color="inherit" /> : <SaveIcon />}
                        disabled={!isScenarioEditable || !dirty || isSaving}
                        onClick={() => saveRow(row)}
                      >
                        {isSaving ? 'Saving' : 'Save'}
                      </Button>
                    </TableCell>
                  </TableRow>
                )
              })}
              {paginatedRows.length === 0 && (
                <TableRow>
                  <TableCell colSpan={10} align="center">
                    <Typography color="textSecondary">No properties match your filters</Typography>
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </div>

        <TablePagination
          rowsPerPageOptions={[10, 25, 50, 100]}
          component="div"
          count={filteredRows.length}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={(event, nextPage) => setPage(nextPage)}
          onRowsPerPageChange={(event) => {
            setRowsPerPage(parseInt(event.target.value, 10))
            setPage(0)
          }}
        />
      </Paper>

      <Snackbar
        open={snackbar.open}
        autoHideDuration={3500}
        onClose={() => setSnackbar(prev => ({ ...prev, open: false }))}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
      >
        <Alert onClose={() => setSnackbar(prev => ({ ...prev, open: false }))} severity={snackbar.severity}>
          {snackbar.message}
        </Alert>
      </Snackbar>
    </div>
  )
}

const mapStateToProps = (state) => ({
  url: state.url
})

export default connect(mapStateToProps)(RoutingTerritoryPropertiesList)
